import service from '@/utils/request'
import { getRefreshToken } from '@/utils/request'

/**
 * 登录
 * @param {{ username: string, password: string }} data
 */
export const login = (data) => service.post('/auth/login', data)

/**
 * 退出登录：携带 refreshToken 让后端立即吊销
 */
export const logout = () => service.post('/auth/logout', { refreshToken: getRefreshToken() })

/** 获取当前用户最新路由列表（角色菜单变更后刷新用） */
export const getMyRoutes = () => service.get('/auth/routes')
